import { render, staticRenderFns } from "./BookingItems.vue?vue&type=template&id=18462b1e&scoped=true&"
import script from "./BookingItems.vue?vue&type=script&lang=js&"
export * from "./BookingItems.vue?vue&type=script&lang=js&"
import style0 from "./BookingItems.vue?vue&type=style&index=0&id=18462b1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18462b1e",
  null
  
)

export default component.exports